import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'

import type {IssueTemplateRow$key} from './__generated__/IssueTemplateRow.graphql'
import {IssueTemplateItem} from './IssueTemplateItem'
import {IssueCreationKind} from './utils/model'
import {getTemplateUrl} from './utils/urls'

type IssueTemplateProps = {
  onTemplateSelected?: (filename: string, kind: IssueCreationKind) => void
  template: IssueTemplateRow$key
  nameWithOwner: string
}

export const IssueTemplateRow = ({nameWithOwner, template, onTemplateSelected}: IssueTemplateProps) => {
  const data = useFragment(
    graphql`
      fragment IssueTemplateRow on IssueTemplate {
        name
        about
        filename
      }
    `,
    template,
  )

  return (
    <IssueTemplateItem
      filename={data.filename}
      onTemplateSelected={filename => onTemplateSelected?.(filename, IssueCreationKind.IssueTemplate)}
      name={data.name}
      about={data.about}
      link={onTemplateSelected ? undefined : getTemplateUrl(nameWithOwner, data.filename)}
    />
  )
}

try{ IssueTemplateRow.displayName ||= 'IssueTemplateRow' } catch {}